import { HTTP, HTTP_COMMON } from "@/api/http-common";
import ENDPOINT from "../endpoints";

export function callApiDangNhap(payload) {
  return new Promise((resolve, reject) => {
    HTTP.defaults.headers = {};
    return HTTP.post(`${ENDPOINT.DANG_NHAP}`, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error.response.data.message);
      });
  });
}

export function callApiDangNhapCaptcha(payload) {
  return new Promise((resolve, reject) => {
    HTTP.defaults.headers = {};
    return HTTP.post(`${ENDPOINT.DANG_NHAP_CAPTCHA}`, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error.response.data.message);
      });
  });
}

export function callApiRefreshToken(payload) {
  return new Promise((resolve, reject) => {
    HTTP.defaults.headers = {};
    return HTTP.post(`${ENDPOINT.REFRESH_TOKEN}`, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error.response.data.message);
      });
  });
}